module.exports = __webpack_public_path__ + "media/images/weather/140_night-dc2532e6e9ea4a4f4b346fc538b4fcbc.png";